import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'

import { useUploadFile } from './useUploadFile'

const document = graphql(`
  mutation DataSettingsPage_GenerateAnswerUploadURL(
    $surveyId: String!
    $filename: String!
    $sheetName: String
    $fileExtension: String!
  ) {
    generateUploadURL: generateAnswerUploadURL(
      surveyId: $surveyId
      filename: $filename
      sheetName: $sheetName
      fileExtension: $fileExtension
    ) {
      url
      awaitId
    }
  }
`)

export const useUploadAnswerFile = () => {
  const { t } = useTranslation()

  return useUploadFile({
    document,
    messages: {
      error: t('could_not_upload_response_data'),
      uploading: t('uploading_response_data'),
      uploaded: t('response_data_uploaded'),
      logEvent: 'Upload answer data',
    },
  })
}
